import { useNavigate } from 'react-router-dom';
import { PURPLE, MINT } from '../../utils/designUtils';

export default function PrivacyPolicyPage() {
    const navigate = useNavigate();

    return (
        <div style={{ background: '#f5f4fa', minHeight: 'calc(100vh - 61px)', padding: '40px clamp(16px, 4vw, 32px) 64px' }}>
            <div style={{ maxWidth: 720, margin: '0 auto' }}>

                <button
                    onClick={() => navigate(-1)}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        background: 'none', border: 'none', cursor: 'pointer',
                        fontSize: 13, color: '#7a7989', marginBottom: 20, padding: 0,
                        fontFamily: 'inherit',
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 5l-7 7 7 7"/>
                    </svg>
                    돌아가기
                </button>

                <div style={{
                    background: 'white', borderRadius: 16,
                    border: '1px solid rgba(124,107,217,0.12)',
                    boxShadow: '0 4px 24px rgba(124,107,217,0.08)',
                    overflow: 'hidden',
                }}>
                    {/* 헤더 */}
                    <div style={{ padding: '28px 32px', borderBottom: '1px solid #f0eff5' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                            <span style={{ width: 4, height: 22, borderRadius: 2, background: `linear-gradient(180deg, ${PURPLE}, ${MINT})`, display: 'inline-block', flexShrink: 0 }}/>
                            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#1f1d2e', letterSpacing: '-0.02em' }}>
                                개인정보처리방침
                            </h1>
                        </div>
                        <p style={{ margin: 0, fontSize: 13, color: '#9896a8', fontWeight: 500 }}>
                            시행일: 2026년 1월 5일
                        </p>
                    </div>

                    <div style={{ padding: '32px', display: 'flex', flexDirection: 'column', gap: 0 }}>

                        <p style={{ margin: '0 0 24px', fontSize: 14, color: '#4a4860', lineHeight: 1.8 }}>
                            solegate(이하 "회사")는 운영하는 웹 서비스 WorkiTalk(이하 "서비스")에서 정보주체의 자유와 권리 보호를 위해
                            「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.
                            이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보의 처리와 보호에 관한 절차 및 기준을 안내하고,
                            이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                        </p>

                        <Section title="1. 수집하는 개인정보 항목 및 수집 방법">
                            <p style={pStyle}>
                                회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>필수 항목: 이름, 이메일 주소, 비밀번호, 전화번호, 생년월일</li>
                                <li style={liStyle}>직업 정보: 소속 조직, 부서, 직함, 고용 상태 및 날짜, 경력, 급여 정보</li>
                                <li style={liStyle}>서비스 이용 기록: 접속 IP, 브라우저 종류 및 버전, 방문 페이지, 이용 일시</li>
                                <li style={liStyle}>알림: 푸시 알림 토큰(FCM)</li>
                            </ul>
                            <div style={noteStyle}>
                                <span style={{ fontSize: 14, color: PURPLE, flexShrink: 0 }}>ℹ</span>
                                <span style={{ fontSize: 13, color: '#6b5bbf', fontWeight: 500, lineHeight: 1.6 }}>
                                    본 서비스는 이용자의 위치 정보를 수집하지 않습니다.
                                </span>
                            </div>
                        </Section>

                        <Section title="2. 개인정보 수집 및 이용 목적">
                            <p style={pStyle}>
                                회사는 수집한 개인정보를 다음 목적으로만 이용합니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>회원 가입 및 본인 확인, 계정 관리</li>
                                <li style={liStyle}>조직·프로젝트·전자결재·보고서 등 서비스 기능 제공</li>
                                <li style={liStyle}>공지사항 전달, 고객 문의 응대</li>
                                <li style={liStyle}>서비스 개선 및 통계 분석</li>
                            </ul>
                        </Section>

                        <Section title="3. 개인정보의 보유 기간 및 파기">
                            <p style={pStyle}>
                                회사는 이용자가 서비스를 이용하는 동안 개인정보를 보유하며, 회원 탈퇴 또는 삭제 요청 시 지체 없이 파기합니다.
                                단, 관계 법령에 따라 일정 기간 보존이 필요한 경우 해당 기간 동안만 보관합니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>전자상거래 계약·청약철회 기록: 5년 (전자상거래법)</li>
                                <li style={liStyle}>접속 로그, 접속 IP: 3개월 (통신비밀보호법)</li>
                            </ul>
                            <p style={pStyle}>파기 방법은 다음과 같습니다.</p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>전자적 파일: 복원이 불가능한 방법으로 영구 삭제</li>
                                <li style={liStyle}>종이 문서: 분쇄기로 분쇄하거나 소각 처리</li>
                            </ul>
                        </Section>

                        <Section title="4. 개인정보의 제3자 제공">
                            <p style={pStyle}>
                                회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만 아래의 경우는 예외로 합니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>이용자가 사전에 동의한 경우</li>
                                <li style={liStyle}>법령의 규정에 의거하거나, 수사·조사 목적으로 법령에 정해진 절차에 따라 요청이 있는 경우</li>
                                <li style={liStyle}>서비스 운영을 위해 위탁 계약을 체결한 업체 (독립적 이용 권한 없음)</li>
                            </ul>
                        </Section>

                        <Section title="5. 쿠키(Cookie) 운영">
                            <p style={pStyle}>
                                서비스는 로그인 유지 등 원활한 서비스 제공을 위해 쿠키를 사용합니다.
                                브라우저 설정에서 쿠키 저장을 거부할 수 있으나, 일부 기능 이용이 제한될 수 있습니다.
                            </p>
                        </Section>

                        <Section title="6. 이용자의 권리">
                            <p style={pStyle}>
                                이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>본인의 개인정보 열람·수정 요청</li>
                                <li style={liStyle}>개인정보 삭제(회원 탈퇴) 요청</li>
                                <li style={liStyle}>개인정보 처리 정지 요청</li>
                            </ul>
                            <p style={pStyle}>
                                권리 행사는 아래 문의처 이메일로 요청하시면 지체 없이 조치합니다.
                            </p>
                        </Section>

                        <Section title="7. 아동 보호">
                            <p style={pStyle}>
                                본 서비스는 만 14세 미만 아동을 대상으로 하지 않으며, 만 14세 미만 아동의 개인정보를 고의로 수집하지 않습니다.
                                해당 사실이 확인될 경우 즉시 파기합니다.
                            </p>
                        </Section>

                        <Section title="8. 개인정보 보호를 위한 기술적·관리적 조치">
                            <p style={pStyle}>
                                회사는 이용자의 개인정보를 안전하게 관리하기 위해 다음과 같은 조치를 취합니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>비밀번호 암호화 저장 및 통신 구간 암호화(HTTPS)</li>
                                <li style={liStyle}>개인정보 접근 권한 최소화 및 접근 이력 관리</li>
                                <li style={liStyle}>보안 취약점 점검 및 정기적인 시스템 점검</li>
                            </ul>
                        </Section>

                        <Section title="9. 개인정보 처리방침 변경">
                            <p style={pStyle}>
                                본 방침은 법령 또는 서비스 변경에 따라 업데이트될 수 있습니다.
                                변경 시 서비스 내 공지사항 또는 본 페이지를 통해 사전 안내하며, 변경 후 서비스를 계속 이용하면 변경 내용에 동의한 것으로 간주합니다.
                            </p>
                        </Section>

                        <Section title="10. 개인정보 보호책임자">
                            <p style={pStyle}>
                                회사는 개인정보 처리에 관한 업무를 총괄하고, 개인정보 관련 불만 처리 및 피해 구제를 위해 다음과 같이 개인정보 보호책임자를 지정하고 있습니다.
                            </p>
                            <div style={{ background: '#f7f6fb', borderRadius: 10, padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 10 }}>
                                {[
                                    { label: '성명', value: '대표 이상준' },
                                    { label: '이메일', value: 'ssolegate@gmail.com' },
                                ].map(({ label, value }) => (
                                    <div key={label} style={{ display: 'flex', gap: 20, fontSize: 13.5 }}>
                                        <span style={{ fontWeight: 600, color: '#3a3849', minWidth: 48 }}>{label}</span>
                                        <span style={{ color: '#5d5b6e' }}>{value}</span>
                                    </div>
                                ))}
                            </div>
                            <p style={{ ...pStyle, marginBottom: 0 }}>
                                개인정보 보호 관련 문의, 불만, 피해 구제 등은 위 연락처로 문의해 주시면 지체 없이 처리하겠습니다.
                            </p>
                        </Section>

                        <Section title="11. 정보주체의 권익침해 구제방법">
                            <p style={pStyle}>
                                이용자는 개인정보 침해로 인한 구제를 받기 위하여 아래 기관에 분쟁 해결이나 상담 등을 신청할 수 있습니다.
                            </p>
                            <ul style={ulStyle}>
                                <li style={liStyle}>개인정보보호위원회 / privacy.go.kr / 국번없이 182</li>
                                <li style={liStyle}>개인정보 분쟁조정위원회 / kopico.go.kr / 국번없이 1833-6972</li>
                                <li style={liStyle}>대검찰청 사이버수사과 / spo.go.kr / 국번없이 1301</li>
                                <li style={liStyle}>경찰청 사이버수사국 / ecrm.cyber.go.kr / 국번없이 182</li>
                            </ul>
                        </Section>

                        {/* 문의처 */}
                        <div style={{ marginTop: 4, borderTop: '1px solid #f0eff5', paddingTop: 28 }}>
                            <div style={{ fontSize: 11.5, fontWeight: 600, color: '#8b8a99', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 12 }}>
                                문의처 (Contact Us)
                            </div>
                            <p style={{ margin: '0 0 14px', fontSize: 14, color: '#4a4860', lineHeight: 1.8 }}>
                                개인정보 보호와 관련하여 궁금한 점이 있으시면 이메일로 연락 주십시오.
                            </p>
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: '#f3f1fc', border: `1.5px solid rgba(124,107,217,0.2)`, borderRadius: 12, padding: '12px 18px' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={PURPLE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                                </svg>
                                <a href="mailto:ssolegate@gmail.com" style={linkStyle}>ssolegate@gmail.com</a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, fontWeight: 800, color: '#1f1d2e', letterSpacing: '-0.01em', margin: '0 0 10px' }}>
                {title}
            </h2>
            {children}
        </div>
    );
}

const pStyle = { margin: '0 0 10px', fontSize: 14, color: '#4a4860', lineHeight: 1.8 };
const ulStyle = { margin: '0 0 10px', paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 };
const liStyle = { fontSize: 14, color: '#4a4860', lineHeight: 1.7 };
const noteStyle = {
    display: 'flex', alignItems: 'flex-start', gap: 8,
    background: '#f3f1fc', border: '1.5px solid rgba(124,107,217,0.2)',
    borderRadius: 12, padding: '10px 14px', marginTop: 8,
};
const linkStyle = { color: '#7C6BD9', textDecoration: 'underline', fontSize: 14 };
